import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  SimpleGrid,
  Text,
  Textarea
} from "@chakra-ui/react";
import { ModeloNegocioType } from "models/modelo_negocio_type";
import moment from "moment";
import InputMask from "react-input-mask";

interface IBussinessModelForm {
  show: boolean;
  showModal: (show: boolean) => void;
  accountSelected: ModeloNegocioType;
  error: boolean;
  textColor: string;
  brandStars: string;
  loading: boolean;
  save: () => void;
  changeInput: (tipo: string, value: string) => void;
  cancelRef: any;
  closeError: () => void;
  errorTitle: string;
  errorMsg: string;
}
const BussinessModelForm = ({
  show,
  showModal,
  accountSelected,
  error,
  textColor,
  brandStars,
  changeInput,
  loading,
  save,
  cancelRef,
  closeError,
  errorMsg,
  errorTitle,
}: IBussinessModelForm) => {
  const mask = "99/99/9999";
  return (
    <Modal
      onClose={() => {
        showModal(false);
      }}
      size={"6xl"}
      isOpen={show}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {accountSelected !== null
            ? "Editar Modelo de Negócio"
            : "Novo Modelo de Negócio"}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <SimpleGrid columns={3} spacing={4}>
            <FormControl isInvalid={error}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                
              >
                Nome<Text color={brandStars}>*</Text>
              </FormLabel>
              <Input
                defaultValue={accountSelected?.nome}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Preencha o nome do modelo de negócio"
                onChange={(e) => changeInput("nome", e.target.value)}
               
                fontWeight="500"
                size="md"
              />
            </FormControl>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                
              >
                Data<Text color={brandStars}>*</Text>
              </FormLabel>
              <Input
                isInvalid={error}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder={"Digite a Data"}
                fontWeight="500"
                defaultValue={
                  moment(accountSelected?.dataCriacao).format("DD/MM/YYYY") ?? moment().format("DD/MM/YYYY")
                }
                size="md"
                as={InputMask}
                onChange={(e) => changeInput("data", e.target.value)}
                mask={mask}
              />
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                
              >
                Validade<Text color={brandStars}>*</Text>
              </FormLabel>
              <Input
                isInvalid={error}
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder={"Digite a validade"}
                fontWeight="500"
                defaultValue={
                  moment(accountSelected?.validade).add({day : 1}).format("DD/MM/YYYY") ??
                  moment().add({ year: 1 }).format("DD/MM/YYYY")
                }
                size="md"
                as={InputMask}
                onChange={(e) => changeInput("validade", e.target.value)}
                onBlur={(e) => changeInput("validade", e.target.value)}
                mask={mask}
              />
            </FormControl>

            <FormControl isInvalid={error}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                
              >
                Meta de Faturamento R$
              </FormLabel>
              <NumberInput
                precision={2}
                step={10000}
                min={0}
                defaultValue={accountSelected?.metaFaturamento}
                onChange={(e: string) => changeInput("metaFaturamento", e)}
              >
                <NumberInputField />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
            </FormControl>

            <FormControl isInvalid={error}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                
              >
                Meta de Lucro %
              </FormLabel>
              <NumberInput
                precision={2}
                step={10}
                max={100}
                min={0}
                defaultValue={accountSelected?.metaLucro}
                onChange={(e: string) => changeInput("metaLucro", e)}
              >
                <NumberInputField />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
            </FormControl>

            <FormControl isInvalid={error}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                
              >
                Custo Fixo %
              </FormLabel>
              <NumberInput
                precision={2}
                step={10}
                max={100}
                min={0}
                defaultValue={accountSelected?.custoFixo}
                onChange={(e: string) => changeInput("custoFixo", e)}
              >
                <NumberInputField />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
            </FormControl>

            <FormControl isInvalid={error}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                
              >
                Custo de Venda %
              </FormLabel>
              <NumberInput
                precision={2}
                step={10}
                max={100}
                min={0}
                defaultValue={accountSelected?.custoVenda}
                onChange={(e: string) => changeInput("custoVenda", e)}
              >
                <NumberInputField />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
            </FormControl>

            <FormControl isInvalid={error}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                
              >
                Imposto %
              </FormLabel>
              <NumberInput
                precision={2}
                step={10}
                max={100}
                min={0}
                defaultValue={accountSelected?.imposto}
                onChange={(e: string) => changeInput("imposto", e)}
              >
                <NumberInputField />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
            </FormControl>

            <FormControl isInvalid={error}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                
              >
                Desconto %
              </FormLabel>
              <NumberInput
                precision={2}
                step={10}
                max={100}
                min={0}
                defaultValue={accountSelected?.desconto}
                onChange={(e: string) => changeInput("desconto", e)}
              >
                <NumberInputField />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
            </FormControl>
          </SimpleGrid>



          <FormControl isInvalid={error}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                
              >
                Descrição<Text color={brandStars}>*</Text>
              </FormLabel>
              <Textarea
                defaultValue={accountSelected?.descricao}
                fontSize="sm"
                height={200}
                ms={{ base: "0px", md: "0px" }}
                placeholder="Preencha a descrição do modelo de negócio"
                onChange={(e) => changeInput("descricao", e.target.value)}
               
                fontWeight="500"
                size="md"
              />
            </FormControl>
          
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={() => {
              showModal(false);
            }}
            variant="outline"
            marginRight={4}
          >
            Fechar
          </Button>
          <Button
            onClick={() => {
              save();
            }}
            colorScheme="brand"
            isLoading={loading}
          >
            Salvar
          </Button>
        </ModalFooter>
      </ModalContent>
      <AlertDialog
        isOpen={error}
        leastDestructiveRef={cancelRef}
        onClose={closeError}
        isCentered
        motionPreset="slideInBottom"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {errorTitle}
            </AlertDialogHeader>

            <AlertDialogBody>{errorMsg}</AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={closeError} colorScheme={"blue"}>
                OK
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Modal>
  );
};
export default BussinessModelForm;
